module.exports = __webpack_public_path__ + "static/img/map.0aedc02.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/map.png
// module id = EoJS
// module chunks = 1